module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.018fdbf0.png";